import React from 'react'
import PropTypes from 'prop-types'

const Form = ({handleSubmit}) => {
  return (
  <>
        <form onSubmit={handleSubmit}>
    <label className="text-left w-50"><input className="w-100" type="text" name="inputText" autoComplete='off' /></label>
    <button className="btn btn-secondary m-2" type="submit">
        Buscar
    </button>
</form>
</>
  )
}

Form.propTypes = {
    handleSubmit: PropTypes.func,
}

export default Form